declare namespace $ {

	export class $shm_hitalama_map_back extends $mol_view {
		event_pointerdown( next?: any ): any
		event_contextmenu( next?: any ): any
		event( ): ({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_back['event_pointerdown'] > ): ReturnType< $shm_hitalama_map_back['event_pointerdown'] >,
			contextmenu( next?: ReturnType< $shm_hitalama_map_back['event_contextmenu'] > ): ReturnType< $shm_hitalama_map_back['event_contextmenu'] >,
		})  & ReturnType< $mol_view['event'] >
	}
	
}

//# sourceMappingURL=back.view.tree.d.ts.map